import React, { FC } from 'react';
import {
  Box,
  Button,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { SelectChangeEvent } from '@mui/material/Select';
import { useBusinessSelection } from '../../hooks/useBusinessSelection';
import { useRegistrationContext } from '../../contexts/RegistrationContext';

interface BusinessSelectionFormProps {
  onNext: () => void;
  onBack: () => void;
}

export const BusinessSelectionForm: FC<BusinessSelectionFormProps> = ({
  onNext,
  onBack,
}) => {
  const { business, availableBusinesses, showBusinessStep, selectBusiness } =
    useBusinessSelection();
  const { updateField } = useRegistrationContext();

  const handleBusinessChange = (event: SelectChangeEvent) => {
    const businessId = +event.target.value;
    selectBusiness(businessId);
    // ✅ ACTUALIZAR EL businessId EN EL FORMULARIO DE REGISTRO
    updateField('businessId', businessId);
  };

  if (!showBusinessStep) {
    return null;
  }

  return (
    <Box sx={{ paddingX: '5%', paddingY: '5vh' }}>
      <Button
        onClick={onBack}
        size="small"
        sx={{ marginY: '2%', fontWeight: 'bold' }}
        variant="text"
      >
        {'← Atras'}
      </Button>
      <FormControl sx={{ width: '100%', marginTop: '10vh' }}>
        <InputLabel id="business-select-label">Empresa</InputLabel>
        <Select
          value={`${business ?? ''}`}
          onChange={handleBusinessChange}
          labelId="business-select-label"
          id="business-select"
          label="Empresa"
          variant="outlined"
          sx={{ width: '100%' }}
        >
          {availableBusinesses.map(bus => (
            <MenuItem key={bus.id} value={bus.id}>
              {bus.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        spacing={12}
      >
        <Button
          disabled={business == null}
          onClick={onNext}
          size="large"
          sx={{ marginY: '5vh', fontWeight: 'bold', borderRadius: '50px' }}
          variant="contained"
        >
          {'Siguiente →'}
        </Button>
      </Stack>
    </Box>
  );
};
